import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import 'vue3-carousel/dist/carousel.css'
import 'tocbot/dist/tocbot.css'
import VueGtag from 'vue-gtag'
import VueSocialSharing from 'vue-social-sharing'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

loadFonts()

// index.html already loads gtag.js for the site's GA property: the legacy template with a
// <script> tag, the security template with a loader that fetches it once the page is idle
// (window.diguAnalyticsLoader holds that property's ID). When vue-gtag is configured with the
// same ID, it would download that library a second time (~200 KB), and right away. Its gtag()
// calls (config, events) go to the same dataLayer either way, so only that download is skipped.
const gaId = process.env.VUE_APP_GA_MEASUREMENT_ID
const gtagAlreadyLoaded =
  !!gaId &&
  (window.diguAnalyticsLoader === gaId || !!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaId}"]`))

const app = createApp(App)
  .use(router)
  .use(vuetify)
  .use(VueGtag, { config: { id: gaId }, disableScriptLoad: gtagAlreadyLoaded })
  .use(VueSocialSharing)
  .use(VueToast)

// A prerendered page (scripts/seo/prerender.mjs) arrives with its content already in #app.
// Mount only once the first route has resolved, so the page is swapped for the identical live
// one in a single frame instead of flashing the spinner and an empty router-view (layout shift).
// If the route's code cannot be downloaded at all (offline), keep the prerendered page as it is
// rather than mounting an empty route over it; its links still work as normal page loads.
if (document.getElementById('app').hasChildNodes()) {
  router.isReady().then(
    () => app.mount('#app'),
    (error) => {
      if (!/chunk|dynamically imported module/i.test(String(error && (error.message || error.name)))) app.mount('#app')
    }
  )
} else {
  app.mount('#app')
}